import { Inject } from 'inversify-props'
import type { RelatorioServiceAdapter } from "./adapter"

export class DeleteRelatorioUseCase {
	@Inject('RelatorioServiceAdapter')
	private relatorioService!: RelatorioServiceAdapter

	removerPreset = async (presetId: string): Promise<void> =>
		await this.relatorioService.removerPreset(presetId)
}